exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/github/490/rec_ng_recibopago490v7/src/app/components/formulario/contenedor-formulario/contenedor-formulario.component.css
// module id = ../../../../../src/app/components/formulario/contenedor-formulario/contenedor-formulario.component.css
// module chunks = main